import React from 'react';
import ChatSidebarMessageBubble from './ChatSidebarMessageBubble';
import ChatSidebarTypingIndicator from './ChatSidebarTypingIndicator';
import ChatAnalysisControls from './ChatAnalysisControls';
import ChatInput from './ChatInput';

// Complete chat messages view including messages, controls, and input
// Extracted from ChatSidebar.jsx lines 942-987
const ChatMessagesView = ({
  messages,
  isTyping,
  autoExpandingMessage,
  tourInProgress,
  setTourInProgress,
  message,
  setMessage,
  messagesEndRef,
  darkMode,
  onSuggestionClick,
  onExpandMessage,
  onInlineButtonClick,
  onSendMessage,
  onStopThinking,
  placeholder = "Ask about your SEO...",
  currentDomain = null,
  portalMode = false,
  currentContext = null, // Added for tutorial truncation detection
  // Progress state for async polling
  isPolling = false,
  currentProgress = 0,
  currentProgressMessage = ''
}) => {
  return (
    <>
      {/* Messages */}
      <div className={`
        flex-1 overflow-y-auto p-4 space-y-4 scrollbar-modern
        ${darkMode ? 'bg-gray-900' : 'bg-gradient-to-b from-purple-50/20 to-pink-50/20'}
      `}>
        {messages.map((msg) => (
          <ChatSidebarMessageBubble 
            key={msg.id} 
            message={msg} 
            darkMode={darkMode} 
            onSuggestionClick={onSuggestionClick}
            onExpandMessage={onExpandMessage}
            onInlineButtonClick={onInlineButtonClick}
            currentDomain={currentDomain}
            isAutoExpanding={autoExpandingMessage === msg.id}
            portalMode={portalMode}
            currentContext={currentContext}
          />
        ))}
        
        {isTyping && <ChatSidebarTypingIndicator 
          darkMode={darkMode} 
          onStop={onStopThinking} 
          isPolling={isPolling}
          currentProgress={currentProgress}
          currentProgressMessage={currentProgressMessage}
        />}
        
        <div ref={messagesEndRef} />
      </div>

      {/* Analysis Controls */}
      <ChatAnalysisControls 
        tourInProgress={tourInProgress}
        setTourInProgress={setTourInProgress}
        darkMode={darkMode}
      />

      {/* Input */}
      <div className={`
        p-3 border-t
        ${darkMode ? 'border-gray-700 bg-gray-900' : 'border-gray-200 bg-white'}
      `}>
        <ChatInput
          value={message}
          onChange={setMessage}
          onSend={onSendMessage}
          disabled={isTyping || tourInProgress}
          darkMode={darkMode}
          placeholder={placeholder}
        />
      </div>
    </>
  );
};

export default ChatMessagesView;
